import styled, { css } from 'styled-components';
import { BodyLight, Colors, H2Heavy, MediaQuery } from '@pelando/components';

export const modalStyle = css`
  @media ${MediaQuery.SCREEN_MD_UP} {
    & > div:first-of-type {
      margin-bottom: 0;
    }

    width: 400px;
    padding: 24px 24px 40px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const CheckAnimationWrapper = styled.div`
  position: relative;
  width: 98px;
  height: 98px;
  margin-bottom: 16px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 170px;
    height: 170px;
    margin-bottom: 8px;
  }
`;

export const CheckAnimation = styled.div`
  width: 140px;
  height: 140px;
  // TODO: mudar o caminho da imagem para uma pasta de assets compartilhada
  background-image: url('/assets/search/alert-incentive-modal-68x68.gif');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 220px;
    height: 220px;
  }
`;

export const Title = styled.h2`
  ${H2Heavy}
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  ${BodyLight}
  color: rgb(${Colors.Gray});
`;
